export default "__VITE_ASSET__DlxFVOne__"